import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "@follosoft/react-components";
import type { RawGatewayConfig } from "@/app/_checkout/types";

export const GATEWAY_CONFIG_KEY = "contract-gateway-config";

// GET contracts/{contract}/gateway-config →
//   { data: { id, type: 'gateway-configs', attributes: <RawGatewayConfig | null> } }
// `attributes` is null when the account has no online-payment processor set up.
export function useGatewayConfigService(contractId: string | number | undefined) {
  return useQuery<RawGatewayConfig | null>({
    queryKey: [GATEWAY_CONFIG_KEY, contractId],
    queryFn: async () => {
      const res = await axiosInstance().get(
        `contracts/${contractId}/gateway-config`,
      );
      return res.data?.data?.attributes ?? null;
    },
    enabled: !!contractId,
    staleTime: Infinity,
    retry: false,
  });
}
